<script>
  import { navigate } from "svelte-routing";
  import { browser } from "../../stores";
  import { rememberSummaryEntry } from "../../helpers/rememberSummaryEntry";

  // props
  export let reportLink,
    summaryLink = null,
    podcastLink = null,
    compact = false;

  // constants
  const useRouter = location.pathname.includes("reports");

  // handlers
  const handleSummaryLink = () => {
    rememberSummaryEntry();
    const destination = `/reports/summaries/${summaryLink}`;
    if (useRouter && browser.name !== "ie") {
      navigate(destination);
    } else {
      location = location.origin + destination;
    }
  };
</script>

<p class={`featured-links ${compact ? "compact" : ""}`}>
  {#if summaryLink}
    <a
      href={`/reports/summaries/${summaryLink}`}
      on:click|preventDefault={handleSummaryLink}
    >
      View Summary
    </a>
  {/if}
  {#if podcastLink}
    <a href={podcastLink} target="_blank"> Video Summary </a>
  {/if}
  <a href={reportLink} target="_blank"> Read Report </a>
</p>

<style>
  .featured-links {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    flex-wrap: wrap;
  }
  a {
    margin-right: 20px;
    margin-bottom: 12px;
    font-size: 16px;
    line-height: 24px;
    font-weight: 500;
    white-space: nowrap;
  }
  .compact a {
    margin-bottom: 8px;
  }
</style>
